import{Subject as t}from"../Subject.js";import{multicast as r}from"./multicast.js";function n(n){return n?r((function(){return new t}),n):r(new t)}export{n as publish};
